import React from 'react';
import './Header.module.css';

const Header = () => {

    return(
        <h1>Tippy Tip</h1>
    );
};

export default Header;